export interface BlogPost {
  slug: string;
  title: string;
  excerpt: string;
  date: string;
  tag: string;
}

export const posts: BlogPost[] = [
  {
    slug: 'comma-compression',
    title: "How I (Spiritually) Won comma.ai's Compression Challenge",
    excerpt:
      "A 178 KB neural network beat the field by 38% on comma.ai's video compression challenge. Five things we noticed dissecting it.",
    date: 'Apr 2026',
    tag: 'Deep Learning',
  },
];
